
import { Mission } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { missionActions } from "./mission.actions";

export interface MissionState {
    missions: Mission.MissionDto[];
    nb: number;
    loading: boolean;
    error?: any,
    warning?: any;
    info?: any;
}

export const initialeState: MissionState = {
    missions: [],
    nb: 0,
    loading: true
}

export const missionReducer = createReducer(
    initialeState,
    on(
        missionActions["[Mission-API]LoadMission"], state => ({
            ...state,
            loading: true
        })
    ),
    on(
        missionActions["[Mission-API]LoadSuccess"], (state, res) => ({
            ...state,
            loading: false,
            missions: res.data?.missions ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        missionActions["[Mission-API]LoadFailed"], (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        }))
)